export default "__VITE_ASSET__BKlWRX5p__"